import React, { useEffect, useState, useCallback } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { useNavigate } from "react-router-dom";

import ConfirmBuyModal from "../components/ConfirmBuyModal";

import { ITreasureContract,NFTContarct, USDTContarct,NFTDataContract } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTDataContractABI from "../abis/NFTDataContractABI.json";

import Loader from "../components/Loader";
import BNB from "../assets/bnb.svg";
import { FaCopy, FaCheck, FaCartArrowDown } from "react-icons/fa";

const MultiNftMarketPlace = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const navigate = useNavigate();
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [allNFTs, setAllNFTs] = useState([]);
  const [visibleNFTs, setVisibleNFTs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusText, setStatusText] = useState({ visible: false });
  const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
  const [allTokenIds, setAllTokenIds] = useState([]);
  const [tradeFundAmount, setTradeFundAmount] = useState("0");
  const [USDTBalance, setUSDTBalance] = useState(null);

  const [selectedNFTs, setSelectedNFTs] = useState([]);
  
const [priceBreakdown, setPriceBreakdown] = useState({
  base: 0,
  extra: 0,
  total: 0,
  isResale: false,
});

  const toggleNFTSelection = (nft) => {
  setSelectedNFTs((prev) => {
    const exists = prev.find((x) => x.tokenId === nft.tokenId);

    if (exists) {
      return prev.filter((x) => x.tokenId !== nft.tokenId);
    } else {
      return [...prev, nft];
    }
  });
};

const getTotalSelectedPrice = () => {
  return selectedNFTs.reduce((sum, nft) => sum + Number(nft.price), 0);
};
  
  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

    const formatBalance2 = (balance) =>
    balance ? parseFloat(balance).toFixed(6) : "0.00";


 const formatISTTime = (timestamp) => {
  if (!timestamp) return "";

  const ts = Number(timestamp); // ⭐ BigInt → Number

  const date = new Date(ts * 1000);

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

  // INIT WEB3
  useEffect(() => {
    if (client?.transport) setWeb3(new Web3(client.transport));
    else if (window.ethereum) setWeb3(new Web3(window.ethereum));
  }, [client]);


    useEffect(() => {
      if (isConnected && address && web3) {
        fetchData();
      }
    }, [address, isConnected, web3]);

  const fetchData = async () => {
      try {
  
        const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
        const _USDTBalance = await USDTInstance.methods.balanceOf(address).call();
        setUSDTBalance(web3.utils.fromWei(_USDTBalance, "ether"));

      } 
      catch (error) {
        console.error("Error Fetching Data:", error);
      }
    };

const loadTradingFund = useCallback(async () => {
  if (!web3 || !address) return;

  try {
    const NFTInstance = new web3.eth.Contract(NFTABI, NFTContarct);

    const data = await NFTInstance.methods
      .getTradingIncomeCapping(address)
      .call();

    setTradeFundAmount(
      web3.utils.fromWei(data.tradeFundAmount, "ether")
    );

  } catch (err) {
    console.error("Trading Fund Error:", err);
  }
}, [web3, address]);

useEffect(() => {
  if (web3 && address) {
    loadTradingFund();
  }
}, [web3, address, loadTradingFund]);

  // ================= STEP 1: LOAD ALL TOKEN IDS =================
//   const loadAllTokenIds = useCallback(async () => {
//     if (!web3) return;

//     setLoading(true);
//     try {
//       const NFT = new web3.eth.Contract(NFTDataContractABI, NFTDataContract);

//       const tokenIds = await NFT.methods
//         .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, false)
//         .call();

//       console.log("TOTAL NFT IDS:", tokenIds.length);
//  const shuffled = shuffleLight(tokenIds, getSeed());
//     setAllTokenIds(shuffled);
//       // setAllTokenIds(tokenIds);
//     } catch (err) {
//       console.error("LOAD TOKEN IDS ERROR:", err);
//     }
//   }, [web3]);

  const loadAllTokenIds = useCallback(async () => {
   if (!web3 || !address) {
    setLoading(false);
    return;
  }
    setLoading(true);
    try {
      const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
      const minPrice = web3.utils.toWei("500", "ether");
      const maxPrice = web3.utils.toWei("500", "ether");
          console.log("CALLING WITH:", address, minPrice, maxPrice);

      const tokenIds = await NFT.methods
        .getAllBotListedNFTs(address,minPrice,maxPrice)
        .call();

      console.log("TOTAL NFT IDS:", tokenIds.length);

      setAllTokenIds(tokenIds);
    } catch (err) {
      console.error("LOAD TOKEN IDS ERROR:", err);
    }
  }, [web3, address]);

useEffect(() => {
  if (web3 && address) {
    loadAllTokenIds();
  }
}, [web3, address]);



useEffect(() => {
  if (!web3 || visibleNFTs.length === 0) return;

  const interval = setInterval(async () => {
    try {
      // const NFT = new web3.eth.Contract(NFTABI, NFTDataContract);
      const NFT = new web3.eth.Contract(NFTDataContractABI, NFTContarct);
      // 🔹 fresh active ids
      const activeIds = await NFT.methods
        .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, false)
        .call();

      const activeSet = new Set(activeIds.map(String));

      // 🔹 remove sold NFTs only
      setVisibleNFTs((prev) => {
        const filtered = prev.filter((nft) =>
          activeSet.has(nft.tokenId.toString())
        );

        return filtered;
      });
    } catch (e) {
      console.error("auto silent refresh error", e);
    }
  }, 25000);

  return () => clearInterval(interval);
}, [web3, visibleNFTs.length, address]);

  
  // ================= STEP 2: LOAD NFT DETAILS BY IDS =================
  const loadNFTDetailsByIds = useCallback(
    async (ids) => {
      if (!web3 || ids.length === 0) return;

      try {
        const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
        const NFTData = new web3.eth.Contract(
          NFTDataContractABI,
          NFTDataContract
        );

        const list = await Promise.all(
          ids.map(async (id) => {
            try {
              const info = await NFT.methods.nftInfo(id).call();
              const details = await NFTData.methods.getNFTDetails(id).call();

              // ❌ OWN NFT REMOVE
              if (
                details.ownerAddr?.toLowerCase() === address?.toLowerCase()
              )
                return null;

              return {
                tokenId: id.toString(),
                price: Number(
                  web3.utils.fromWei(info.priceUSDT, "ether")
                ),
                owner: details.ownerAddr,
                image: info.imageURI,
                onSaleTime: info.onSaleTimeStamp   // ⭐ ADD THIS
              };
            } catch {
              return null;
            }
          })
        );

        setVisibleNFTs(list.filter(Boolean));
      } catch (err) {
        console.error("LOAD NFT DETAILS ERROR:", err);
      }
      setLoading(false);
    },
    [web3, address]
  );

  // ================= STEP 3: PAGINATION BASED FETCH =================
  useEffect(() => {
    if (allTokenIds.length === 0) {
        setVisibleNFTs([]);
        setLoading(false);
        return;
      }


    const start = (currentPage - 1) * pageSize;
    const end = currentPage * pageSize;

    const pageIds = allTokenIds.slice(start, end);

    loadNFTDetailsByIds(pageIds);
  }, [allTokenIds, currentPage, pageSize, loadNFTDetailsByIds]);

  // ================= PAGINATION =================
  const totalRecords = allTokenIds.length;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  // ============================================================
  // BUY NOW → OPEN MODAL
  // ============================================================
    const handleBuyNow = (nft) => {
    setSelectedNFT(nft);
    setShowModal(true);
    setStatusText({
      visible: false,
      type: "",
      title: "",
      message: "",
      persist: false,
    });
  };

  const handleMultiBuy = () => {
  const totalPrice = getTotalSelectedPrice();

  const extra = (totalPrice * 10) / 100;
  const finalTotal = totalPrice + extra;

  setPriceBreakdown({
    base: totalPrice,
    extra: extra,
    total: finalTotal,
    isResale: true,
  });

  setShowModal(true);
};

  const PreAuthorizeNFT = async () => {
    try {

        // ⭐ STEP 1: USER REGISTERED CHECK
          const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
          const user = await Contract.methods.objUser(address).call();
          if (!user?.userId || user.userId === "0") {
            setStatusText({
              visible: true,
              type: "error",
              title: "Not Registered",
              message: "Your account is not activated yet Please purchase to complete your registration.",
              persist: true,
              setStatusText,
            });
            return; // ❌ STOP HERE (MetaMask will NOT open)
          }

          const ContractNFT = new web3.eth.Contract(NFTABI, NFTContarct);
          const userCapping = await ContractNFT.methods.getUserCappingStatus(address).call();

          const availableCapping = window.BigInt(userCapping.availableCapping);
      
const totalPrice = getTotalSelectedPrice();
// 🔥 10% EXTRA
const extra = (totalPrice * 10) / 100;
const finalTotal = totalPrice + extra;
setPriceBreakdown({
  base: totalPrice,
  extra: extra,
  total: finalTotal,
  isResale: true,
});
const priceWei = window.BigInt(
  web3.utils.toWei(finalTotal.toString(), "ether")
);
// 2️⃣ +2 token → wei → BigInt
// const twoWei = window.BigInt(
//   web3.utils.toWei("2", "ether")
// );
        // const approveAmount = priceWei +twoWei;

        // //  STEP 3: CAPPING CHECK (IMPORTANT)
        if (priceWei > availableCapping) {
          setStatusText({
            visible: true,
            type: "error",
            title: "Capping Limit Exceeded",
            message:
              "You cannot purchase this NFT because it exceeds your available capping limit.",
            persist: true,
          });
          return false; //  STOP (MetaMask will NOT open)
        }
      const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

      setStatusText({
        visible: true,
        type: "loading",
        title: "Approving USDT",
        message: "Please wait…",
      });

      const allowance = await USDT.methods
        .allowance(address, NFTContarct)
        .call();

      if (window.BigInt(allowance) >= window.BigInt(priceWei)) return true;

      await USDT.methods
        .approve(NFTContarct, priceWei)
        .send({ from: address });

      return true;
    } catch (err) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Approval Failed",
        message: err.message,
        persist: true,
        // ensure modal can close by clicking OK or X — modal will call status.onClose if provided
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
        },
      });
      return false;
    }
  };

   const BuyNFT = async () => {
  try {

    const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

    const totalPrice = getTotalSelectedPrice();

    const totalWei = web3.utils.toWei(totalPrice.toString(), "ether");

    setStatusText({
      visible: true,
      type: "loading",
      title: "Buying NFTs",
      message: "Please wait…",
      persist: false,
    });

    await NFT.methods
      .buyNFTPool(address, totalWei)
      .send({ from: address });

    setSelectedNFTs([]);
    await loadAllTokenIds();
    setCurrentPage(1);
    setStatusText({
      visible: true,
      type: "success",
      title: "Success",
      message: `NFTs Purchased Successfully`,
      persist: true,
      onClose: () => {
        setStatusText({ visible: false });
        setShowModal(false);
      },
    });

  } catch (err) {

    setStatusText({
      visible: true,
      type: "error",
      title: "Purchase Failed",
      message: err.message,
      persist: true,
    });

  }
};



  // ============================================================
  // FINAL CONFIRM BUTTON INSIDE MODAL
  // ============================================================
    const handleConfirm = async () => {
    const approved = await PreAuthorizeNFT();
    if (!approved) return;
  
    await BuyNFT();
  };

  const [copiedIndex, setCopiedIndex] = useState(null);
  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1200);
  };

  const maskAddress = (addr) =>
    addr ? addr.slice(0, 4) + "***" + addr.slice(-4) : "";

  if (loading) return <Loader />;

  return (
    <div className="page">

<style>

{`

.checkbox{
position:absolute;
top:10px;
left:10px;
transform:scale(1.3);
cursor:pointer;
}

.buy-bar{
position:fixed;
bottom:0;
left:0;
right:0;
background:#111;
border-top:1px solid #333;
padding:15px;
display:flex;
justify-content:space-between;
align-items:center;
z-index:999;
}

.buy-info{
color:#fff;
display:flex;
gap:20px;
font-size:15px;
}

.buy-btn{
background:#f0b90b;
border:none;
padding:12px 25px;
border-radius:8px;
font-weight:600;
cursor:pointer;
}

`}

</style>


      <h4 className="mb-3">
        <span className="text-warning">Multiple NFT</span>{" "}
        <span className="fw-lighter">Marketplace</span>
      </h4>

{/* trading Balance section start */}
<>
<style>
{`
.trading-fund-box{
  display:flex;
  justify-content:space-between;
  align-items:center;
  background:linear-gradient(135deg,#1c1c1c,#111);
  border:1px solid rgba(240,185,11,0.35);
  border-radius:12px;
  padding:14px 18px;
  margin-bottom:18px;
  box-shadow:0 0 12px rgba(240,185,11,0.25);
}

.fund-left{
  display:flex;
  align-items:center;
  gap:8px;
}

.fund-icon{
  font-size:18px;
  color:#f0b90b;
}

.fund-left span{
  font-size:14px;
  color:#bbb;
}

.fund-right{
  font-size:18px;
  color:#f0b90b;
  font-weight:700;
}

/* Mobile Responsive */
@media(max-width:768px){

.trading-fund-box{
  padding:12px 14px;
}

.fund-left span{
  font-size:13px;
}

.fund-right{
  font-size:16px;
}

}
`}
</style>

<div className="trading-fund-box">
  <div className="fund-left">
    <span className="fund-icon">💰</span>
    <span>Available Wallet USDT Balance</span>
  </div>

  <div className="fund-right">
    {formatBalance2(USDTBalance)} USDT
  </div>
</div>
</>
{/* trading Balance section End */}



      {/* NFT GRID */}
      <div className="row">
        {visibleNFTs.map((nft, i) => (
          <div className="col-md-4 col-lg-3 mb-4" key={i}>
            <div className="nft">
              <div className="main">
              {/* start check box */}
                <div className="checkbox-box">
                  <input
                    type="checkbox"
                    checked={selectedNFTs.some((x) => x.tokenId === nft.tokenId)}
                    onChange={() => toggleNFTSelection(nft)}
                  />
                </div>
              {/* End check box */}

                <img
                  className="tokenImage"
                 src={`${nft.image}?v=${nft.tokenId}-${Date.now()}`}
                  alt="NFT"
                  style={{ borderRadius: 10 }}
                />

                <h2>NFT #{nft.tokenId}</h2>

               {/* NFTsaletimestamp */}
                <p style={{fontSize:"12px", color:"#aaa", marginTop:"4px"}}>
                Listed : {formatISTTime(nft.onSaleTime)}
                </p>

                <div className="tokenInfo">
                  <div className="price">
                    <ins>◘</ins>
                    <p>{formatBalance(nft.price)} USDT</p>
                  </div>
                  <div className="duration">
                    <ins>◷</ins>
                    <p>ON SALE</p>
                  </div>
                </div>

                <hr />

                <div className="creator">
                  <div className="wrapper">
                    <img
                      src={BNB}
                      alt="BNB"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                  </div>

                  <p>
                    <ins>Owner</ins> {maskAddress(nft.owner)}
                  </p>

                  <div className="ref-copy-box">
                    <button
                      className="copy-btn"
                      onClick={() => handleCopy(nft.owner, i)}
                    >
                      {copiedIndex === i ? (
                        <FaCheck className="copy-icon copied" />
                      ) : (
                        <FaCopy className="copy-icon" />
                      )}
                    </button>
                  </div>
                </div>

                {/* <button
                  className="new_joining_btn"
                  onClick={() => handleBuyNow(nft)}
                >
                  <FaCartArrowDown className="me-2" />
                  Buy Now
                </button> */}
                {/* <div style={{textAlign:"center", marginTop:"20px"}}>

                  <button
                    className="new_joining_btn"
                    disabled={selectedNFTs.length === 0}
                    onClick={() => setShowModal(true)}
                  >
                  
                  Buy Selected NFTs ({selectedNFTs.length})
                  
                  </button>
                  
                </div> */}
              </div>
            </div>
          </div>
        ))}

    {/* buy All NFT BUTOON Start */}
      {selectedNFTs.length>0 &&(
        
        <div className="buy-bar">
        
        <div className="buy-info">
        
        <span>
        Selected : <b>{selectedNFTs.length}</b>
        </span>
        
        <span>
        Total : <b>{formatBalance(getTotalSelectedPrice())} USDT</b>
        </span>
        
        </div>
        
        <button
        className="buy-btn"
        onClick={handleMultiBuy}
        >
        
        Buy Selected NFTs
        
        </button>
        
        </div>
        
        )}

        {/* ✅ SKELETON → ONLY WHEN NFT = 0 */}
        {loading && visibleNFTs.length === 0 &&
          Array.from({ length: pageSize }).map((_, i) => (
            <div className="col-md-4 col-lg-3 mb-4" key={"s" + i}>
              <div className="skeleton-card">
                <div className="skeleton-box"></div>
                <div className="NFT-card-body">
                  <div className="skeleton-line w-50"></div>
                  <div className="skeleton-line w-30"></div>
                </div>
              </div>
            </div>
          ))}

                {visibleNFTs.length === 0 &&
            Array.from({ length: pageSize }).map((_, i) => (
              <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
                <div className="skeleton-card">
                  <div className="skeleton-box"></div>
                  <div className="NFT-card-body">
                    <div className="skeleton-line w-50"></div>
                    <div className="skeleton-line w-30"></div>
                  </div>
                </div>
              </div>
            ))}
        </div>

      {/* Total Counter */}
         <div className="d-flex justify-content-between align-items center"> 
 
      </div>
      {/* Pagination */}
      <div className="pagination-box">
        <button disabled={currentPage === 1} onClick={prevPage}>
          Previous
        </button>
        <button disabled={currentPage === totalPages} onClick={nextPage}>
          Next
        </button>
      </div>

      {/* MODAL HERE */}
      <ConfirmBuyModal
        open={showModal}
        pkg={{
           price: priceBreakdown.total,   // 🔥 MAIN FIX,
          count: selectedNFTs.length
        }}
         purchaseType="nft"
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        status={statusText}
        setStatusText={setStatusText} 
        priceBreakdown={priceBreakdown}  // 🔥 ADD THIS
      />
    </div>
  );
};

export default MultiNftMarketPlace;
